import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import App from './App'
import router from './router'
import store from './store'
import PortalVue from 'portal-vue'
import BootstrapVue, {ToastPlugin} from 'bootstrap-vue'
import Vuex from 'vuex'
import UUID from 'vue-uuid';
import VueMoment from 'vue-moment'
import VueBarcodeScanner from 'vue-barcode-scanner'

Vue.use(VueCookies);
Vue.use(PortalVue);
Vue.use(BootstrapVue);
Vue.use(ToastPlugin);
Vue.use(Vuex);
Vue.use(UUID);
Vue.use(require('vue-faker'));
Vue.use(VueMoment);
Vue.use(VueBarcodeScanner);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
});
